import * as React from 'react';

import './icon-styles.css';

export const DeleteIcon = () => {
    return (
        <img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABoAAAAaCAYAAACpSkzOAAAACXBIWXMAAAsSAAALEgHS3X78AAAA8klEQVRIie2VzQ2CQBBGnz8Hj5agHWAF0olaghVAB9ZgGd60Aj16kxI4etNsHMzIDguC8cRLJpDZmf12F/ItPW0ZfNGXAstS7iT5WpoKRcAZuAC55KaSX0g+yNgYLCYoCzn2atJIIpYejV5QJa7x0THi8uTWjtxqtsBOnrXHonZY2WMJ5arQPY9eRRjz2IbhnjepOo61BJJr9Nc1FUqU0EqiEEq8aoOmQp3phXqh/wtZzmDh3CGTvLaXrIVzfFAYq2eOAYI9dUdXtv8Qwdqqi8813eTdc+IKijtrbpnqyCt/cQcOwAyYeKM2V2CjvmXPDwCeT/o3qa0pS8UAAAAASUVORK5CYII="></img>
    );
};



// WEBPACK FOOTER //
// ./src/App/shared/icons/pt-icon-delete.tsx